module.exports = __webpack_public_path__ + "static/media/sommarlager_tavling_small.205d3198.jpg";